import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useQueryClient } from 'react-query';

import { useWidgetListGet } from 'hooks/useWidget';
import CommonTable from 'components/CommonTable';

const Widget = () => {
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();

  const pageNum = searchParams.get('p') || 1;
  const { data } = useWidgetListGet({ page: Number(pageNum) });
  const { list, totalCnt } = data || { list: [], totalCnt: 0 };

  const totalPage = Math.ceil(totalCnt / 10) === 0 ? 1 : Math.ceil(totalCnt / 10);

  useEffect(() => {
    queryClient.refetchQueries(['widgetList', pageNum]);
  }, [pageNum, queryClient]);

  return <CommonTable type='widget' list={list} totalPage={totalPage} />;
};

export default Widget;
